import React, {FC} from 'react';
import messages from './messages';
import AsyncItemPicker from 'components/async-item-picker';
import SectionSeparator from 'components/separator/section-separator';
import TextInput from 'components/text-input';
import {useTranslation} from 'react-i18next';
import {Col, Row} from 'reactstrap';
import {ValidationErrors} from 'services/api/types';
import {Option} from 'types/option';

interface Props {
  params: any;
  onChangeParams: (x: any) => void;
  validationErrors: ValidationErrors;
  is_locked?: boolean;
}

const QuotationVtaAndTaxes: FC<Props> = props => {
  const {params, onChangeParams, validationErrors, is_locked} = props;

  const {t} = useTranslation();

  return (
    <div>
      <SectionSeparator title={t(...messages.title())} />

      <Row>
        <Col md={12} className="">
          <TextInput
            label={t(...messages.quotationVtaNumber())}
            data-testid="product-name-input"
            value={params.vat_number}
            disabled={is_locked}
            errors={validationErrors.vat_number}
            onChange={vat_number => {
              onChangeParams({
                ...params,
                vat_number,
              });
            }}
          />
        </Col>
        <Col md={12} className="my-2">
          <AsyncItemPicker
            key={'with-vat-' + !!params.with_vat}
            endPoint="data/vat-modes"
            disabled
            label={t(...messages.quotationVtaMode())}
            getOptionLabel={(x: Option) => x.label}
            getOptionValue={(x: Option) => x.value}
            errors={validationErrors.vat_mode}
            value={params.vat_mode}
            onChange={vat_mode => onChangeParams({...params, vat_mode})}
          />
        </Col>
        <Col md={12} className="my-2">
          <div className="form-check my-3">
            <input
              className="form-check-input"
              type="checkbox"
              disabled={is_locked}
              id="is-detaxed"
              onChange={() =>
                onChangeParams({
                  ...params,
                  is_detaxed: !params.is_detaxed,
                  with_vat: false,
                })
              }
              checked={params.is_detaxed}
            />
            <label className="form-check-label" htmlFor="is-detaxed">
              {t(...messages.quotationVatIncluded())}
            </label>
          </div>
          <div className="form-check my-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="with-vat"
              disabled={is_locked}
              onChange={() =>
                onChangeParams({
                  ...params,
                  with_vat: !params.with_vat,
                  is_detaxed: false,
                })
              }
              checked={params.with_vat}
            />
            <label className="form-check-label" htmlFor="with-vat">
              {t(...messages.quotationVatExcluded())}
            </label>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default QuotationVtaAndTaxes;
